var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselPaintbrush = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "67hamt258a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#67hamt258a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(10.022 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.73 37.351v17.63c.468.442.91.66 1.197.773 2.17.85 4.42-.762 4.69-.96.268-.199.47-.386.596-.508V35.611l-6.483 1.742v-.002z",
    fill: "#F8C75F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFDC8D",
    fillRule: "nonzero",
    transform: "rotate(-15.21 24.963 36.478)",
    cx: 24.963,
    cy: 36.478,
    rx: 3.343,
    ry: 1.351
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.276 4.878 1.929-.714a.573.573 0 0 1 .773.533v5.753c0 .273-.103.538-.29.738L26.04 24.874a2.395 2.395 0 0 0-.635 1.6l-.097 9.917",
    stroke: "#B3B1B1",
    strokeWidth: 0.853,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.393 15.312 30.943 0c1.322.139 2.254.565 2.806.879 3.422 1.947 3.8 6.152 3.84 6.67a8.919 8.919 0 0 1-.222 2.711L9.472 27.1l-6.08-11.79v.002z",
    fill: "#D1E7ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8DBBC7",
    fillRule: "nonzero",
    transform: "rotate(-27.1 6.43 21.208)",
    cx: 6.43,
    cy: 21.208,
    rx: 3.829,
    ry: 6.633
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#608891",
    fillRule: "nonzero",
    transform: "rotate(-27.1 6.15 21.207)",
    cx: 6.15,
    cy: 21.207,
    rx: 1.65,
    ry: 2.856
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselPaintbrush);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-paintbrush.7d5829a60e82e4b979f3de7201e6847a.svg";